import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { YesNoQuestion } from '../../order-selection/er-kit-selection/yes-no-question/YesNoQuestion';
import { useRootStore } from '../../root/RootStoreHooks';
import { MeoWarning } from '../../order-selection/er-kit-selection/MeoWarning';

export const FirstErAsTemplateQuestion = observer(() => {
  const { t } = useTranslation();
  const root = useRootStore();
  const store = root.moduleStores.erKitSelection ?? root.moduleStores.socialLinkErKitSelection!;
  const meoStore = root.moduleStores.meoKitSelection!;
  const erKitStore= root.moduleStores.enrollmentKitSelection!;
  const socialLinkKitStore= root.moduleStores.socialLinkErKitSelection!;
  const enrollmentrKitSelectionStore = root.moduleStores.enrollmentKitSelection ?? root.moduleStores.socialLinkEntry!; 
  return (
    <>
      <YesNoQuestion
        value={store.useFirsErOrderAsTemplate}
        onChange={value => store.updateUseFirsErOrderAsTemplate(value)}
        whenYes={t('FirstErAsTemplateQuestion_Yes')}
        whenNo={t('FirstErAsTemplateQuestion_No')}
        question={t('FirstErAsTemplateQuestion_Question')}
      />

  {((socialLinkKitStore?.useFirsErOrderAsTemplate && meoStore?.canProceed()) && (erKitStore?.selectedKit && !erKitStore?.selectedKit.isAutoShipAvailable)) &&  (
        <MeoWarning
          type={meoStore.getWarningType()}
          minimumEnrollmentPv={enrollmentrKitSelectionStore?.minimumEnrollmentOrderPv}
          minimumErPv={enrollmentrKitSelectionStore?.minimumErPv}
        />
      )}
    </>
  );
});
